<template>
	<div
		:class="{ 'd-flex align-center justify-space-between': horizontal }"
	>
		<p
			:class="{ 'mb-0': horizontal }"
			class="text-center font-weight-medium"
			v-html="label"
		></p>
		<div>
			<div class="d-flex align-center justify-center">
				<v-btn
					:class="{ success: value == true }"
					class="mr-3"
					:disabled="disabled"
					@click="onClickBtn(true)"
					>Si</v-btn
				>
				<v-btn
					:class="{ error: value == false }"
					:disabled="disabled"
					@click="onClickBtn(false)"
					>No</v-btn
				>
			</div>
			<v-slide-y-transition>
				<p
					v-if="!!errorMessage"
					class="mb-0 mt-2 text-center red--text"
				>
					{{ errorMessage }}
				</p>
			</v-slide-y-transition>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		label: {
			type: String,
			required: true,
		},
		value: {
			type: Boolean,
			default: null,
		},
		horizontal: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: null,
		},
		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		onClickBtn(value) {
			this.$emit("input", value);
			this.$emit("change");
		},
	},
};
</script>